<template>
    <el-dialog class="ttl-box" v-model="obj.view" width="25%" title="新增评论" :before-close="handleClose">
        <wcinput :option="{placeholder:'请填写评论内容',inputtype:'textarea',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'100%'}" 
            :value="obj.content"
            @finish="(val)=> {
                obj.content=val.value;             
            }"
        />
        <div class="ttl-btn-box top20">
            <wcbutton :option="{title:'取消',type:'del'}" class="right10" @click="handleClose" />
            <wcbutton :option="{title:'确定'}" @click="addComment" />
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: ['view'],
    components:{},
    data() {
        return {
            obj: {
                view:false,
                content:'',
            },
        }
    },
    watch: {
        view(val) {
            if(val) {
                this.obj.view=true;
                this.obj.content='';
            }
        }
    },
    methods: {

        // 关闭弹窗
        handleClose() {
            this.obj.view=false;
            this.$emit('finish',{content:''});
        },

        // 新增评论
        addComment() {
            if(!this.obj.content) {
                this.$notice({message:'请填写评论内容',type:'warning'});
                return;
            }
            this.obj.view=false;
            this.$emit('finish',{content:this.obj.content});
        },


    },
}
</script>
<style scoped>
.ttl-goods {padding:20px 15px 50px 15px;width:calc(100% - 30px);}
.ttl-member-info {display: inline-flex;align-items: center;width:100%;font-size:0;}
.ttl-member-info i {font-style: normal;color:#666eeb;font-size:13px;cursor: pointer;}
.ttl-member-info .el-image {width:80px;height:80px;border-radius: 50%;box-shadow: 0 0 10px #dddddd;}
.ttl-member-info span {display: inline-flex;align-items: center;font-size:13px;color:#666666;}
.ttl-frozen {box-shadow: 0 !important;width:20px !important;height: 20px !important;}
.ttl-member-status {display: inline-flex;align-items: center;}

.ttl-goods-table {display:inline-block;width:100%;}
.ttl-goods-table table {width:100%;border-color: #EBEDF0;padding:0;}
.ttl-goods-table table th {background-color: #EBEDF0;}
.ttl-goods-table table th,.ttl-goods-table table td {padding:20px;font-size:13px;color:#333333;font-weight: normal;}
.ttl-goods-table .el-image {width:60px;height: 60px;border-radius: 50%;box-shadow: 0 0 10px #EBEDF0;}
.numbers {color:#666eeb;cursor: pointer;}
.TTL-renew-detail {display: inline-block;width:100%;}
.TTL-renew-title {display: inline-block;width:100%;font-size:13px;color:#666666;}
::v-deep(.el-textarea__inner) {height: 150px;}
.ttl-btn-box {display: inline-block;width:100%;display: inline-flex;justify-content: flex-end;align-items: center;}
</style>